
export class WorkgroupDto {
  id: string = "";
  name: string = "";

  administrators: string[] = [];
}

export class WorkgroupRequestDto {
  name: string = "";
}